module.exports = __webpack_public_path__ + "img/logo.5e1fcea2.png";